export const incomingAlarmListState = {
    isLoading: false,
    alarmList: [],
    errorCode: 0,
    messageLabel: '',    
    statusCode: 0,
    imageList: [],
    alarmReceiverList:[],
     regionList:[],
}